import React, { useEffect, useState } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import { useMutation, useQuery } from '@apollo/client'
import { FormProvider, useForm } from 'react-hook-form'
import { yupResolver } from '@hookform/resolvers/yup'
import * as Yup from 'yup'
import ContentHeader from '../../../../Layout/ContentHeader'
import { toastSweetAlert } from '../../../../Helpers/ToastSweetAlert'
import Box from '../../../../Global/Box'
import InputController from '../../../../Global/InputController'
import { useLoading } from '../../../../../LoadingOverlay/LoadingOverlayContext'
import { arrayTypeFilesForm } from '../../../../../const/arrayTypeFilesForm'
import {
  CREATE_FORM_FIELD,
  GET_ALL_FORM_FIELDS_BY_FORM_ID,
  GET_ONE_FORM_FIELD_BY_ID,
  UPDATE_FORM_FIELD,
} from '../../../../../graphql/Catalog/Forms/formFields'
import { GET_ALL_FORMS } from '../../../../../graphql/Catalog/Forms/forms'
import { GET_ALL_FORM_FIELDS_TYPES } from '../../../../../graphql/Catalog/Forms/formFieldTypes'
import { GET_ALL_CHOSSEN_SOURCE_BY_TYPE } from '../../../../../graphql/Catalog/Forms/formFieldTypeChoosenSource'

export const FormFieldsNew = () => {
  const { formId, id: _id } = useParams()
  const history = useHistory()
  const { showLoading, hideLoading } = useLoading()

  //STATES
  const [optionsFieldTypes, setOptionsFieldTypes] = useState([])
  const [isChoosenSource, setIsChoosenSource] = useState(false)
  const [isTypeFile, setIsTypeFile] = useState(false)
  const [optionsFieldChoosenSource, setOptionsFieldChoosenSource] =
    useState(null)
  const [selectedFieldChoosenSource, setSelectedFieldChoosenSource] =
    useState('')
  const [selectedFileTypesAllowed, setSelectedFileTypesAllowed] = useState('')

  //MUTATIONS:
  const [getAllChossenSource] = useMutation(GET_ALL_CHOSSEN_SOURCE_BY_TYPE)

  const [create] = useMutation(CREATE_FORM_FIELD, {
    refetchQueries: [
      {
        query: GET_ALL_FORM_FIELDS_BY_FORM_ID,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
          formId: parseInt(formId),
        },
      },
      {
        query: GET_ALL_FORMS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  const [update] = useMutation(UPDATE_FORM_FIELD, {
    refetchQueries: [
      {
        query: GET_ONE_FORM_FIELD_BY_ID,
        variables: { formFieldId: parseInt(_id) },
      },
      {
        query: GET_ALL_FORM_FIELDS_BY_FORM_ID,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
          formId: parseInt(formId),
        },
      },
      {
        query: GET_ALL_FORMS,
        variables: {
          limit: 10,
          offset: 0,
          searchQuery: null,
        },
      },
    ],
  })

  //QUERIES:
  const {
    data: dataResp,
    loading,
    error,
  } = useQuery(GET_ONE_FORM_FIELD_BY_ID, {
    variables: {
      formFieldId: parseInt(_id),
    },
  })

  const {
    loading: loadingFieldTypes,
    error: errorFieldTypes,
    data: dataFieldTypes,
  } = useQuery(GET_ALL_FORM_FIELDS_TYPES, {
    variables: {
      limit: null,
      offset: null,
      searchQuery: null,
    },
    fetchPolicy: 'no-cache',
  })

  //FORM:
  const validationSchema = Yup.object().shape({
    label: Yup.string().required('Campo requerido'),
    name: Yup.string().required('Campo requerido'),
    placeholder: Yup.string().required('Campo requerido'),
    order: Yup.number()
      .positive('El campo Cantidad debe ser positivo')
      .integer('El campo Cantidad debe ser un número entero')
      .required('Campo requerido')
      .typeError('El campo debe ser un numero'),
    col_width: Yup.number()
      .min(1, 'Minimo debe ser de 1')
      .max(12, 'Maximo es de 12')
      .positive('El campo Cantidad debe ser positivo')
      .integer('El campo Cantidad debe ser un número entero')
      .required('Campo requerido')
      .typeError('El campo debe ser un numero'),
    field_type_id: Yup.string().required('Campo requerido'),
  })

  const {
    methods,
    handleSubmit,
    formState: { errors },
    control,
    reset,
    setValue,
  } = useForm({
    resolver: yupResolver(validationSchema),
  })

  const processData = async (data) => {
    if (
      data.TypeOfField.name === 'choosen_db' ||
      data.TypeOfField.name === 'choosen_json'
    ) {
      const {
        data: { getAllFormFieldTypeChoosenSourceByType: respSource },
      } = await getAllChossenSource({
        variables: { type: data.TypeOfField.name },
      })

      const list = respSource.map((item) => {
        return {
          value: item.id,
          label: item.description,
        }
      })
      setOptionsFieldChoosenSource(list)
      setIsChoosenSource(true)
      setSelectedFieldChoosenSource(data.field_type_choosen_source_id)
    }

    if (data.TypeOfField.name === 'file' || data.TypeOfField.name === 'files') {
      setIsTypeFile(true)
      setSelectedFileTypesAllowed(data.file_types_allowed)
    }

    const dataFormated = {
      label: data.label,
      name: data.name,
      placeholder: data.placeholder,
      field_type_id: data.field_type_id,
      field_type_choosen_source_id: data.field_type_choosen_source_id,
      order: data.order,
      col_width: data.col_width,
      file_types_allowed: data.file_types_allowed,
    }

    reset(dataFormated)
  }

  const handleSelectFieldType = async (item) => {
    if (item.name === 'choosen_db' || item.name === 'choosen_json') {
      setOptionsFieldChoosenSource([])
      setSelectedFieldChoosenSource('')

      const {
        data: { getAllFormFieldTypeChoosenSourceByType: respSource },
      } = await getAllChossenSource({
        variables: { type: item.name },
      })

      const list = respSource.map((item) => {
        return {
          value: item.id,
          label: item.description,
        }
      })

      setOptionsFieldChoosenSource(list)
      setSelectedFieldChoosenSource('')
      setIsChoosenSource(true)
      setValue('field_type_choosen_source_id', null)

      setIsTypeFile(false)
      setSelectedFileTypesAllowed('')
      setValue('file_types_allowed', null)

      return
    }

    if (item.name === 'file' || item.name === 'files') {
      setOptionsFieldChoosenSource([])
      setSelectedFieldChoosenSource('')
      setIsChoosenSource(false)
      setValue('field_type_choosen_source_id', null)

      setIsTypeFile(true)
      setSelectedFileTypesAllowed('')
      setValue('file_types_allowed', null)

      return
    }

    setOptionsFieldChoosenSource([])
    setSelectedFieldChoosenSource('')
    setIsChoosenSource(false)
    setValue('field_type_choosen_source_id', null)

    setIsTypeFile(false)
    setSelectedFileTypesAllowed('')
    setValue('file_types_allowed', null)
  }

  //EFFECTS:
  useEffect(() => {
    if (!loading) {
      if (_id) {
        if (error) {
          //setLoadingBtn(false)
          return toastSweetAlert({
            mode: 'error',
            message: error.message,
          })
        }

        if (dataResp !== undefined && dataResp !== null) {
          const data = dataResp.getOneFormFieldById
          processData(data)
        }
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [_id, dataResp, error, loading])

  useEffect(() => {
    if (!loadingFieldTypes) {
      if (errorFieldTypes)
        return toastSweetAlert({
          mode: 'error',
          message: errorFieldTypes.message,
        })

      const list = dataFieldTypes?.getAllFormFieldTypes?.rows?.map((item) => {
        return {
          value: item.id,
          label: item.description,
          name: item.name,
        }
      })
      setOptionsFieldTypes(list)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loadingFieldTypes, errorFieldTypes, dataFieldTypes])

  const onSubmit = async (dataForm) => {
    if (
      isChoosenSource &&
      (!dataForm.field_type_choosen_source_id ||
        dataForm.field_type_choosen_source_id === '')
    ) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Se requiere elegir campo fuente de lista',
      })
    }

    if (
      isTypeFile &&
      (!dataForm.file_types_allowed || dataForm.file_types_allowed === '')
    ) {
      return toastSweetAlert({
        mode: 'error',
        message: 'Se requiere elegir campo tipo de archivo permitido',
      })
    }

    showLoading()

    //setLoadingBtn(true)
    try {
      const input = {
        form_id: parseInt(formId),
        label: dataForm.label,
        name: dataForm.name,
        placeholder: dataForm.placeholder,
        field_type_id: parseInt(dataForm.field_type_id),
        field_type_choosen_source_id: dataForm.field_type_choosen_source_id
          ? parseInt(dataForm.field_type_choosen_source_id)
          : null,
        order: parseInt(dataForm.order),
        col_width: parseInt(dataForm.col_width),
        file_types_allowed: dataForm.file_types_allowed
          ? parseInt(dataForm.file_types_allowed)
          : null,
      }

      if (_id) {
        await update({ variables: { id: parseInt(_id), input } })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Se actualizo correctamente',
          },
          history.push(`/catalog/forms/${formId}/fields`)
        )
      } else {
        await create({ variables: { input } })
        return toastSweetAlert(
          {
            mode: 'ok',
            message: 'Se creo con exito',
          },
          history.push(`/catalog/forms/${formId}/fields`)
        )
      }
    } catch (error) {
      //setLoadingBtn(false)
      return toastSweetAlert({
        mode: 'error',
        message: error.message,
      })
    } finally {
      hideLoading()
    }
  }

  return (
    <>
      <ContentHeader
        title=""
        breadcrumb="custom"
        breadcrumbContent={
          <div className="col-12">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <Link to={`/catalog/forms`}>Lista Formulario </Link>
              </li>
              <li className="breadcrumb-item">
                <Link to={`/catalog/forms/${formId}/fields`}>Campos / </Link>
              </li>
              <li className="breadcrumb-iteem active">{`${
                _id ? 'Actualizar' : 'Agregar'
              } campo `}</li>
            </ol>
          </div>
        }
        windowTitle={`${_id ? 'Actualizar' : 'Agregar'} campo `}
      />

      <FormProvider {...methods}>
        <form className="p-3" onSubmit={handleSubmit(onSubmit)}>
          <Box
            title={`${
              _id ? 'Actualizar campo del' : 'Agregar nuevo campo al'
            } formulario`}
            btnRedPath={`/catalog/forms/${formId}/fields`}
            btnRedTxt="Cancelar"
            errors={errors}
            btnSubmit={true}
            content={
              <>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="Plantilla"
                      name="label"
                      type="text"
                      placeholder="Escribe label"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="Nombre campo"
                      name="name"
                      type="text"
                      placeholder="Escribe nombre"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="Marcador de posición"
                      name="placeholder"
                      type="text"
                      placeholder="Escribe placeholder"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="#Ordenamiento"
                      name="order"
                      type="text"
                      placeholder="Escribe #ordenamiento"
                      control={control}
                    />
                  </div>
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="Tamaño (1-12)"
                      name="col_width"
                      inputType="number"
                      placeholderTxt="Escribe tamaño"
                      control={control}
                      maxLength={2}
                    />
                  </div>
                </div>
                <div className="row">
                  <div className="mb-3 col-12 col-sm-4">
                    <InputController
                      label="Tipo de campo"
                      name="field_type_id"
                      control={control}
                      inputType="choosen"
                      options={optionsFieldTypes}
                      changeAction={(e) => handleSelectFieldType(e)}
                    />
                  </div>
                </div>
                {optionsFieldChoosenSource && isChoosenSource && (
                  <div className="row">
                    <div className="mb-3 col-12 col-sm-4">
                      <InputController
                        label="Fuente de la lista"
                        name="field_type_choosen_source_id"
                        control={control}
                        inputType="choosen"
                        options={optionsFieldChoosenSource}
                        valueManual={selectedFieldChoosenSource}
                        changeAction={(e) =>
                          setSelectedFieldChoosenSource(e.value)
                        }
                      />
                    </div>
                  </div>
                )}

                {isTypeFile && (
                  <div className="row">
                    <div className="mb-3 col-12 col-sm-4">
                      <InputController
                        label="Tipo de archivo permitido"
                        name="file_types_allowed"
                        control={control}
                        inputType="choosen"
                        placeholderTxt="Elige un tipo"
                        options={arrayTypeFilesForm}
                        valueManual={selectedFileTypesAllowed}
                        changeAction={(e) =>
                          setSelectedFileTypesAllowed(e.value)
                        }
                      />
                    </div>
                  </div>
                )}
              </>
            }
          />
        </form>
      </FormProvider>
    </>
  )
}
export default FormFieldsNew
